<template>
  <iRow
    width="fill"
    height="hug"
    wrap="wrap"
    gap="extraSmall"
  >
    <template
      v-for="tag in tags"
      :key="tag"
    >
      <iLink
        v-if="tagHref(tag)"
        :href="tagHref(tag)"
        v-bind="fullTextOptionsAttributes"
      >
        #{{ tag }}
      </iLink>
      <iText
        v-else
        v-bind="fullTextOptionsAttributes"
      >
        #{{ tag }}
      </iText>
    </template>
  </iRow>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import { StaticBrandedTextElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/static-branded-text-element-mixin";
import LinkTags from "%/dynamic-component-editor/options/link-tags";

// Generic display element for `stringArray` fields — a row of "#tag" chips
// (hashtags being the canonical case). With Link Tags on (the default), each
// chip links to the destination's tag page (`${links.web}/stories/<tag>` —
// the same URL the ClickAction hashtag link type builds); off, the chips are
// plain text. Minted by the palette for every stringArray field
// (InspireEntity #elementComponentByFieldType).
export default {
  name: "DynamicAppTagListElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, StaticBrandedTextElementMixin],
  elementPanelSettings: {
    displayName: "Tag List",
    elementGroup: "general",
    displayIcon: "text",
    elementType: "element",
  },
  hidden: true,
  options: [
    LinkTags,
  ],
  computed: {
    isEditable() {
      return false;
    },
    tags() {
      const value = this.valueFromContext;
      if (Array.isArray(value) && value.length > 0) {
        return value.filter(tag => typeof tag === "string" && tag.length > 0);
      }
      // Canvas preview falls back to the field's exampleData, else a
      // representative placeholder.
      if (this.editMode || this.isPreviewMode) {
        const example = this.exampleData;
        if (Array.isArray(example) && example.length > 0) {
          return example;
        }
        return ["tag"];
      }
      return [];
    },
  },
  methods: {
    tagHref(tag) {
      if (this.editMode || this.getOptionValue(LinkTags) !== true) {
        return null;
      }
      // links is store state seeded async ([] until setLinks) — unlinked, not a broken href, until web is set.
      const webBase = this.links?.web;
      if (!webBase) {
        return null;
      }
      return `${webBase}/stories/${encodeURIComponent(tag)}`;
    },
  },
};
</script>
